<template>
  <form method="get" class="searchBar">
    <span @click="resetSearch" class="icon-close searchBar__reset"></span>
    <input type="text"
           name="s"
           v-model="searchcmd"
           @change="addOverlay"
           @focusin="addOverlay"
           class="form-control searchBar__input"
           autocomplete="off"
           :placeholder="placeholder">
    <button @click.prevent="go" class="btn btn-secondary btn-lg" v-html="label.button_label"></button>

    <div v-if="showSuggestions" class="suggestBox searchBar__suggestions">

      <span class="small">
        <span v-if="searchcmd.length === 0" v-html="label.suggestions_example"></span>
        <span v-else v-html="label.suggestions_search"></span>
      </span><br>
      <span class="btn bg-light m-2" @click="searchBadge(tag.name)" v-for="tag in suggestions.badges" v-html="tag.name"></span>

      <template v-if="searchcmd.length > 0">
        <hr><span class="small" v-html="label.suggestions_direct"></span><br>
        <ul class="list-unstyled mb-0">
          <li v-for="link in suggestions.links">
            <span v-if="link.type !== 'debug'" :class="'icon-' + link.type + ' text-purple'"></span>
            <a v-if="link.type !== 'debug'" :href="link.guid" v-html="link.post_title"></a>
          </li>
        </ul>
      </template>
    </div>
  </form>
</template>

<script>
  import search from '@/js/service/search';

  export default {
    name: 'search',
    props: {
      query: {
        type: String,
        required: false
      },
      reload: {
        type: Boolean,
        required: false,
        default: false,
      },
      placeholderText: {
        type: String,
        required: true,
      },
      searchIn: {
        type: Array,
        required: false,
        default: () => ([
          "jobs",
          "events",
          "post",
          "product",
          "page"
        ])
      },
      label: {
        type: Object,
        required: true,
      }
    },
    watch: {
      searchcmd(value) {
        clearTimeout(this.suggestTimeout);
        if (value.length === 0) {
          return;
        }

        this.suggestTimeout = setTimeout(() => {
          this.getSuggestions(value.trim());
        }, 300);
      }
    },
    data() {
      return {
        searchcmd: this.query,
        placeholder: '',
        placeholderInterval: undefined,
        suggestTimeout: undefined,
        showSuggestions: false,
        suggestions: {
          badges: [],
          links: []
        }
      }
    },
    mounted() {
      window.addEventListener('click', (event) => {
        if (!event.target.classList.contains('searchBar__input')) {
          this.removeOverlay();
        }
      });
      this.removeOverlay();

      search.get(this.searchcmd.trim(), { type: [...this.searchIn] })
        .then((response) => {
          // @todo: Append post_meta parameters from_date for event archive page
          this.removeOverlay();
          this.$emit('postSearch', response.data, false);
        })
        .catch(error => {
          this.removeOverlay();
          this.$emit('postError');
        });
      this.animatePlaceholder();
    },
    methods: {
      animatePlaceholder() {
        const animateText = this.placeholderText;
        let start = 0;

        this.placeholderInterval = setInterval(() => {

          this.placeholder += animateText[start];
          start += 1;

          if (start >= animateText.length) {
            clearInterval(this.placeholderInterval);
          }
        }, 50);
      },

      go() {
        this.removeOverlay();
        this.$emit('postSearch', [], true);
        if (this.reload) {
          var sanitizedSearchCmd = this.searchcmd.replace(/RI&E/g, 'RIE');
          window.location.href = `/?s=${encodeURIComponent(sanitizedSearchCmd.trim().split(' ').join('+'))}`;
          return;
        }
        // @todo: Append post_meta parameters from_date for event archive page
        search.get(this.searchcmd.trim(), {type: [...this.searchIn]})
          .then((response) => {
            this.removeOverlay();
            this.$emit('postSearch', response.data, false);
          })
          .catch(error => {
            this.removeOverlay();
            this.$emit('postError');
          });
      },

      /**
       * Get search suggestions.
       */
      getSuggestions() {
        search.suggestions(this.searchcmd)
          .then((response) => {
            this.setBadges(response.data.badges);
            this.setLinks(response.data.links);
            this.addOverlay();
          });
      },

      /**
       * Search on badge.
       * @param {string} tagName
       */
      searchBadge(tagName) {
        this.searchcmd = tagName;
        this.removeOverlay();
        this.go();
      },

      setBadges(badges) {
        let values = [];

        Object.keys(badges).forEach((tax) => {
          badges[tax].forEach((term) => {
            values.push(term);
          });
        });

        values.sort((a,b) => (a.sort_order - b.sort_order));
        this.suggestions.badges = values;
      },

      setLinks(links) {
        if (links.length === 0) {
          return;
        }

        this.suggestions.links = links;
        this.suggestions.links.sort((a,b) => (a.sort_order - b.sort_order));
      },

      resetSearch() {
        this.removeOverlay();
        this.searchcmd = '';
      },

      removeOverlay() {
        document.body.classList.remove('overlay');
        this.showSuggestions = false;
      },

      addOverlay() {
        if (this.searchcmd.length === 0) {
          return;
        }
        this.showSuggestions = true;
        document.body.classList.add('overlay');
      }
    }
  }
</script>

<style scoped>
  .suggestBox {
    width: calc(80% - 1.5rem - 3rem / 2);
  }
</style>
